import { defineComponent } from 'vue';
import { useStore } from 'vuex';
export default defineComponent({
  props: {
    plugin: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  emits: ['handlePluginClick', 'clearAppTimer', 'pollPlugin'],
  setup() {
    return {
      store: useStore()
    };
  },
  methods: {
    handleClick(action) {
      if (this.plugin.inProgress !== 'not-in-progress') return;
      this.$emit('handlePluginClick', action, this.plugin, this.index);
    },
    handelShowAction(plugin) {
      if (plugin.showAction) {
        this.$emit('pollPlugin');
      } else {
        this.$emit('clearAppTimer');
      }
      plugin.showAction = !plugin.showAction;
    }
  }
});